import React, { useEffect, useState, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import '@fullcalendar/core/index.cjs';
import '@fullcalendar/daygrid/index.cjs';
import { getSupervisors } from '../../services/supervisors';
import { getDriverAttendanceByMonth, getDrivers } from '../../services/drivers';
import 'bootstrap/dist/css/bootstrap.min.css';
import { USER_ID, USER_TYPE } from '../../api/axios';

const DriverAttendanceCalendar = () => {
  const [supervisors, setSupervisors] = useState([{ id: 0, user: { username: 'Select' } }]);
  const [drivers, setDrivers] = useState([{ id: 0, user: { username: 'Select' } }]);
  const [selSupervisor, setSelSupervisor] = useState(0);
  const [selUserId, setUserId] = useState(0);
  const [selDriver, setSelDriver] = useState(0);
  const [frmDate, setFrmDate] = useState('');
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  const calendarRef = useRef(null);

  useEffect(() => {
    const currentUser = sessionStorage.getItem(USER_TYPE);
    const isAdminUser = currentUser.toLowerCase() === 'admin';
    const userId = sessionStorage.getItem(USER_ID);
    setUserId(userId);
    setIsAdmin(isAdminUser);
    if (isAdminUser) {
      fetchSupervisors(isAdminUser, userId);
    } else {
      fetchDrivers(userId);
    }
  }, []);

  const fetchSupervisors = async () => {
    // Example
    try {
      const res = await getSupervisors();
      let options = [];
      res.forEach(spv => {
        // if (isAdminUser) {
        options.push(spv);
        //  }
      });
      setSupervisors(options);
      // setSelSupervisor(options[0].user.id);
    } catch (err) {
      console.error(err);
      setSupervisors([]); // fallback to avoid undefined
    }
  };

  const handleSupervisorChange = async e => {
    setDrivers([]);
    setFrmDate([]);
    const selectedId = e.target.value;
    if (!selectedId || selectedId === '' || selectedId === 0) {
      console.log('No valid supervisor selected yet');
      return;
    }
    setSelSupervisor(selectedId);
    console.log(selSupervisor);
    if (selectedId) {
      fetchDrivers(selectedId);
    } else {
      setDrivers([]);
    }
  };

  const fetchDrivers = async supervisorId => {
    setDrivers([]);
    try {
      if (!supervisorId) return;

      const res = await getDrivers(supervisorId);
      setDrivers(res || []);
    } catch (error) {
      console.error('Failed to fetch drivers', error);
      setDrivers([]); // fallback to empty list
    }
  };

  const getDriverAttendance = async () => {
    try {
      const res = await getDriverAttendanceByMonth(
        isAdmin ? selSupervisor : null,
        frmDate,
        selDriver
      );

      const data = res.attendance || {};
      const presentDates = data[selDriver]?.map(item => item.date) || [];

      // Get year & month from frmDate (YYYY-MM)
      const [year, month] = frmDate.split('-');
      const daysInMonth = new Date(year, month, 0).getDate();

      // Today's date in YYYY-MM-DD
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0];

      const events = [];

      for (let day = 1; day <= daysInMonth; day++) {
        const dayStr = String(day).padStart(2, '0');
        const fullDate = `${year}-${month}-${dayStr}`;

        if (presentDates.includes(fullDate)) {
          events.push({ title: 'Present', date: fullDate, color: 'green' });
        } else {
          // Only mark absent if before today
          if (fullDate < todayStr) {
            events.push({ title: 'Absent', date: fullDate, color: 'red' });
          }
        }
      }

      setCalendarEvents(events);

      if (calendarRef.current) {
        const calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(frmDate + '-01');
      }
    } catch (err) {
      console.error(err);
      //  toast.error('Failed to fetch attendance');
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="page-header">
        <h4>ATTENDANCE</h4>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row">
            {/* Supervisor */}
            {isAdmin && (
              <div className="col-md-3">
                <label>Supervisor</label>
                <select
                  className="form-select"
                  value={selSupervisor}
                  onChange={handleSupervisorChange}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {supervisors.map(s => (
                    <option key={s.user.id} value={s.user.id}>
                      {s.user.username}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Driver */}
            <div className="col-md-3 pt-1">
              <div className="form-group">
                <label>Driver</label>
                <select
                  className="form-select"
                  value={selDriver}
                  onChange={e => setSelDriver(e.target.value)}
                >
                  <option value={0}>Select</option>
                  {drivers.map(d => (
                    <option key={d.user.id} value={d.user.id}>
                      {d.user.username}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Month */}
            <div className="col-md-2">
              <div className="form-group">
                <label>Month</label>
                <input
                  type="month"
                  className="form-control"
                  value={frmDate}
                  onChange={e => setFrmDate(e.target.value)}
                />
              </div>
            </div>

            {/* View Button */}
            <div className="col-md-2 d-flex align-items-end">
              <button
                className="bg-orange text-black px-4 py-2 rounded"
                onClick={getDriverAttendance}
              >
                VIEW
              </button>
            </div>
          </div>

          {/* Calendar */}
          <div className="compact-calendar mt-3">
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              height="auto"
              weekends={true}
              events={calendarEvents}
              headerToolbar={{
                left: '',
                center: 'title',
                right: '',
              }}
              editable={false}
              selectable={false}
              navLinks={false}
              eventClick={info => info.jsEvent.preventDefault()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverAttendanceCalendar;
